import { useState } from "react";
import { MainLayout } from "../layout/MainLayout";
import { DashboardPage } from "../../pages/DashboardPage";
import { ArchDesignerPage } from "../../pages/ArchDesignerPage";
import { ArchitecturePage } from "../../pages/ArchitecturePage";

export type AppPageKey = "dashboard" | "arch-designer" | "architecture";

export function AppRouter() {
  const [activePage, setActivePage] = useState<AppPageKey>("dashboard");

  const renderPage = () => {
    switch (activePage) {
      case "dashboard":
        return <DashboardPage onNavigate={setActivePage} />;
      case "arch-designer":
        return <ArchDesignerPage />;
      case "architecture":
        return <ArchitecturePage />;
      default:
        return <DashboardPage onNavigate={setActivePage} />;
    }
  };

  return (
    <MainLayout activePage={activePage} onNavigate={setActivePage}>
      {renderPage()}
    </MainLayout>
  );
}